// extracted by mini-css-extract-plugin
module.exports = {"footer__home":"style_footer__home__35W_F","footer__item":"style_footer__item__lCxv7","credits":"style_credits__44-hR"};